export default __webpack_public_path__ + "static/media/lush_garden.5032c67d.webp";